// Small helpers shared by the chat components

export const getInitials = (name) => {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return "?";
  }
  const first = parts[0][0] || "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase();
};

// Group chats have their own id (1-1 chats do not, Stream makes it from the two members)
export const createGroupChannelId = () => {
  const random =
    window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;

  return `grp_${random}`;
};

// react-select inside a react-bootstrap modal: keep the dropdown above the modal
export const selectInModalProps = {
  menuPortalTarget: document.body,
  menuPosition: "fixed",
  styles: {
    menuPortal: (base) => ({ ...base, zIndex: 2000 }),
  },
};
